(function () {
  var CODE = 'KVAPAI10';
  var PERCENT = 10;
  var MIN_ITEMS = 3;

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('en-IE', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100) + ' ' + cur;
    }
  }

  function bundleItems(quiz, keys) {
    return keys.map(function (k) { return quiz.pick(k, 'small'); }).filter(function (p) { return p && p.available; });
  }

  function decorate(quiz) {
    quiz.querySelectorAll('[data-sq-action=bundle]').forEach(function (btn) {
      if (btn.getAttribute('data-sq-offer')) return;
      var keys = btn.getAttribute('data-keys').split(',');
      var items = bundleItems(quiz, keys);
      if (keys.length < MIN_ITEMS || items.length < MIN_ITEMS) return;
      var total = items.reduce(function (n, p) { return n + p.price; }, 0);
      var discounted = Math.round(total * (100 - PERCENT) / 100);
      var label = btn.querySelector('.btn-text');
      if (label) label.innerHTML = 'Išbandyti visus ' + items.length + ' – <s style="opacity:.6">' + money(total) + '</s> ' + money(discounted);
      btn.setAttribute('data-sq-offer', '1');
      var host = btn.parentElement;
      if (host && !host.querySelector('.sq__offer')) {
        var note = document.createElement('p');
        note.className = 'sq__offer';
        note.textContent = '−' + PERCENT + ' % nuolaida pritaikoma automatiškai, kai renkiesi visus ' + items.length + ' kvapus.';
        btn.insertAdjacentElement('afterend', note);
      }
    });
  }

  customElements.whenDefined('sentire-quiz').then(function () {
    var proto = customElements.get('sentire-quiz').prototype;
    var renderResult = proto.renderResult;
    var addBundle = proto.addBundle;

    proto.renderResult = function () {
      renderResult.apply(this, arguments);
      decorate(this);
    };

    proto.addBundle = function (el) {
      var self = this;
      var args = arguments;
      var keys = (el.getAttribute('data-keys') || '').split(',');
      if (keys.length >= MIN_ITEMS && bundleItems(this, keys).length >= MIN_ITEMS) {
        try {
          if (window.dataLayer) window.dataLayer.push({ event: 'quiz_bundle_discount_applied', discount_code: CODE });
        } catch (e) {}
        fetch('/discount/' + CODE, { credentials: 'same-origin' }).catch(function () {}).then(function () { addBundle.apply(self, args); });
        return;
      }
      addBundle.apply(this, args);
    };
  });
})();